import React from 'react';
import MenuItemList from './MenuItemList';
import { filterNotHiddenItem } from 'common/utilities/utils';

const MenuSubCategoryItemList = props => {
  return filterNotHiddenItem(props.subCategory).map(({ categories = '', products = [], id = '', dname }, index) => {
    return (
      <div id={id} key={index}>
        <div
          className={
            props.cardType === 'large'
              ? 'large-subcategory-name'
              : (props.cardType === 'medium' && 'medium-subcategory-name') ||
                (props.cardType === 'carousal' && 'carousal-subcategory-name') ||
                (props.cardType === 'small' && 'small-subcategory-name') ||
                null
          }
        >
          <div>{dname[0].value}</div>

          {categories}
        </div>
        <MenuItemList
          productList={products}
          cardType={props.cardType}
          tenantData={props.tenantData}
          categoryId={id}
          catalogs={props.catalogs}
          storeClosedData={props.storeClosedData}
          specialEventItemAvailability={props.specialEventItemAvailability}
        />
      </div>
    );
  });
};

export default MenuSubCategoryItemList;
